import React, { useState } from 'react';
import { Tabs } from 'antd';
import { FileTextOutlined, BookOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import PatientDocuments from './PatientDocuments';
import PatientEducation from './PatientEducation';

const { TabPane } = Tabs;

const PatientDocumentsAndHealthLibrary = ({ patientId }) => {
  const { t } = useTranslation();
  const [activeNestedTab, setActiveNestedTab] = useState('documents');

  return (
    <div>
      <Tabs
        activeKey={activeNestedTab}
        onChange={setActiveNestedTab}
        type="card"
        size="default"
        style={{ marginTop: 0 }}
        tabBarStyle={{
          marginBottom: 16,
          '@media (max-width: 575px)': {
            fontSize: '12px'
          }
        }}
      >
        <TabPane 
          tab={
            <span>
              <FileTextOutlined />
              Patient Documents
            </span>
          } 
          key="documents"
        >
          <PatientDocuments patientId={patientId} />
        </TabPane>
        
        <TabPane 
          tab={
            <span>
              <BookOutlined />
              {t('patientChart.tabs.education')}
            </span>
          } 
          key="health-library"
        >
          <PatientEducation patientId={patientId} />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default PatientDocumentsAndHealthLibrary;
